/**  @module Sourcing/EditSupplierRequest */
define([
    "dojo/_base/declare",
    "csi/action/EditController"
], function(declare,EditController) {

    return declare(EditController, {
        /**
         * @override
         *
         * Refresh line items table
         */
        postProcessSuccess: function() {
            // summary: refresh table
            const lineItemsView = this.widget.getSiblingView("StyleLineItems")    ||
                                  this.widget.getSiblingView("MaterialLineItems") ||
                                  this.widget.getSiblingView("FoodLineItems")     ||
                                  this.widget.getSiblingView("FormulatedMaterialLineItems");
            if (lineItemsView) {
	            lineItemsView.refreshData();
	        }
	        this.inherited(arguments);
        }

    });
});